import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WinterModeService {

  private readonly WINTER_MODE_KEY = 'winterMode';

  public winterSeason = signal<boolean>(false);

  public statusWinterMode = signal<boolean>(false);

  constructor() {
    const winterMode = this._getSeasonalDefault();
    this.winterSeason.set(winterMode);

    if (this.winterSeason()) {
      this._checkEnableWinterMode();
    }
  }

  public changeStatusWinterMode(): void {
    this._saveWinterMode(!this.statusWinterMode());
  }

  private _checkEnableWinterMode(): void {
    const loadedWinterMode = this._loadWinterMode();

    if (loadedWinterMode === null) {
      this._saveWinterMode(this.winterSeason());
    } else {
      this._saveWinterMode(loadedWinterMode);
    }
  }

  private _saveWinterMode(value: boolean): void {
    localStorage.setItem(this.WINTER_MODE_KEY, JSON.stringify(value));
    this.statusWinterMode.set(value);
  }

  private _loadWinterMode(): boolean | null {
    const saved = localStorage.getItem(this.WINTER_MODE_KEY);

    if (saved === null) {
      return null;
    }

    return JSON.parse(saved);
  }

  private _getSeasonalDefault(): boolean {
    const month = new Date().getMonth();
    return month === 11 || month === 0 || month === 1;
  }
}
